import { StandardEvents } from '@shopify/events';
let version = 0;
let dismissTimer;
function hideConfirmation() {
  document.querySelectorAll('[data-zx-cart-confirmation]').forEach(element => { element.hidden = true; });
}
document.addEventListener('click', event => {
  if (event.target instanceof Element && event.target.closest('[data-zx-cart-dismiss]')) hideConfirmation();
});
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  const requestVersion = ++version;
  if (!event.promise) return;
  event.promise.then(async ({ detail }) => {
    if (detail?.didError) return;
    const header = document.querySelector('[data-zx-cart-url]');
    if (!header) return;
    const response = await fetch(header.dataset.zxCartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (requestVersion !== version || !Number.isInteger(cart.item_count)) return;
    document.querySelectorAll('.zx-basket').forEach(link => {
      const count = link.querySelector('span');
      if (count) count.textContent = String(cart.item_count);
      if (link.dataset.zxCartLabel) link.setAttribute('aria-label', link.dataset.zxCartLabel.replace('__count__', String(cart.item_count)));
    });
    if (detail?.source === 'product-form-component') {
      const confirmation = document.querySelector('[data-zx-cart-confirmation]');
      if (confirmation) {
        confirmation.hidden = false;
        clearTimeout(dismissTimer);
        dismissTimer = setTimeout(hideConfirmation, 12000);
      }
    }
  }).catch(() => {});
});
